import { useEffect, useMemo } from "react"
import { useDispatch } from "react-redux"
import { listMyOrgs } from "../Actions/API/Org/OrgMemberActions"
import { isAuthenticated } from "../Helpers/Functions/Selectors/auth"
import { APIOrgMember } from "../Models/API/APIOrgMember"
import { FetchState } from "../Models/Client/FetchState"
import { getItemList } from "../Models/Client/RemoteData"
import { Result } from "../Models/Utility/Result"
import { useAppState } from "./useReduxState"

export function useOrgs(): FetchState<APIOrgMember[]> {
    const dispatch = useDispatch()
    const remoteData = useAppState(state => state.api.orgs.myOrgs)
    const authenticated = useAppState(isAuthenticated)

    useEffect(() => {
        if (remoteData.list === undefined && authenticated) {
            dispatch(listMyOrgs())
        }
    }, [authenticated, dispatch, remoteData.list])

    return useMemo(() => {
        return remoteData.list === undefined
            ? undefined
            : Result.ok(getItemList(remoteData))
    }, [remoteData])
}
